import { hasCompanyPurchaseSupport } from './companySubscriptionHelper'

export default ({ product, isUserAuthenticated, subscription, screen }) => {
  if (hasCompanyPurchaseSupport(product)) {
    return isUserAuthenticated || screen === 'purchase' ? 'purchase' : 'initial'
  }

  return 'subscription'
}
